import type { AuthState, Role } from './resolveAccess';

/** "Xem như": chỉ admin dùng được, giao diện đổi menu/nút/trang mở được; server đổi danh tính cho mọi lần ĐỌC (header `x-view-as`) và chặn mọi lần ghi. */
export interface PreviewIdentity { id: string; name: string; role: Exclude<Role, 'admin'> }

/** Vai trò thật của `me` là admin thì thay `me.role` bằng vai trò đang xem; không thì trả nguyên trạng thái. */
export function applyPreview(state: AuthState, preview: PreviewIdentity | null): AuthState {
  if (state.status !== 'ready' || !preview || state.me.role !== 'admin') return state;
  return { status: 'ready', me: { ...state.me, role: preview.role } };
}

/**
 * Id của NGƯỜI ĐANG XEM: người được "Xem như" nếu có, không thì chính phiên đăng nhập. Dùng cho mọi truy vấn ĐỌC "của tôi".
 * KHÔNG thay cho `me.id` (phiên thật); khi xem như, server tự đổi danh tính và không cho ghi.
 */
export function viewerIdOf(state: AuthState, preview: PreviewIdentity | null): string | null {
  if (state.status !== 'ready') return null;
  return preview && state.me.role === 'admin' ? preview.id : state.me.id;
}
